import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import ParametersTableHeader from '../../Blocks/ParametersTableHeader';
import ParametersTypeValue from '../../Blocks/ParametersTypeValue';
import ReturnTypeValue from '../../Blocks/ReturnTypeValue';

function Vi(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="getrecords">
                1.&nbsp;<span className="material-symbols-outlined">format_list_bulleted</span>&nbsp;{translate('getrecords')}
            </Typography>
            <p><strong>{translate('getrecords')}</strong> là một hành động truy xuất các bản ghi.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là nơi lưu trữ đầu ra của hành động này.</td>
                                <td>$records_1</td>
                            </tr>
                            <tr>
                                <td>{translate('providerid')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là <strong>ID nhà cung cấp</strong> của kết nối Filemaker (xem <Box component={Link} to="/control-center/documentation/connections/filemaker">tại đây</Box> để tạo kết nối).</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('layout')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là tên layout.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('params')}</td>
                                <td>
                                    <ParametersTypeValue type="object" />
                                </td>
                                <td>Là một tham số truy vấn.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="object" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$records_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('providerid')}</span>
                            <div>filemaker-1a2b3c4d5e6g7h</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('layout')}</span>
                            <div>Task Details</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('params')}</span>
                            <div>{`{"_ limit": "1"}`}</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                        {
                                            "response": {
                                                "dataInfo": {
                                                    "database": "Sample",
                                                    "layout": "Task Details",
                                                    "table": "task",
                                                    "totalRecordCount": 3,
                                                    "foundCount": 3,
                                                    "returnedCount": 3
                                                },
                                                "data": [
                                                    {
                                                    "fieldData": {
                                                        "description": "",
                                                        "completion date": "",
                                                        "status": "",
                                                        "priority": "",
                                                        "category": "",
                                                        "Deadline": "",
                                                        "Task": ""
                                                    },
                                                    "portalData": {
                                                        "Attachment": [],
                                                        "Responsible Portal": []
                                                    },
                                                    "recordId": "34",
                                                    "modId": "0",
                                                    "portalDataInfo": [
                                                        {
                                                        "database": "Sample",
                                                        "table": "Attachment",
                                                        "foundCount": 0,
                                                        "returnedCount": 0
                                                        },
                                                        {
                                                        "portalObjectName": "Responsible Portal ",
                                                        " database ": " Sample ",
                                                        " table ": " Assignment ",
                                                        " foundCount ": 0,
                                                        " returnedCountedCount ": 0
                                                        }
                                                    ]
                                                    },
                                                    {
                                                    "fieldData ": {
                                                        " Description ": " ",
                                                        " Completion date ": "",
                                                        "Status": "Completed",
                                                        "Priority": "",
                                                        "Category": "",
                                                        "Deadline": "",
                                                        "Task": "Test"
                                                    },
                                                    "portalData": {
                                                        " Attached Files ": [],
                                                        " Contact Portal ": []
                                                    },
                                                    " recordId ": " 36 ",
                                                    " modId ": " 1 ",
                                                    " portalDataInfo ": [
                                                        {
                                                        "database ": " Sample ",
                                                        " table ": "Attachment",
                                                        "foundCount": 0,
                                                        "returnedCount": 0
                                                        },
                                                        {
                                                        "portalObjectName": "Person in charge portal",
                                                        "database": "Sample",
                                                        "table": "Assignment",
                                                        "foundCount": 0,
                                                        "returnedCount": 0
                                                        }
                                                    ]
                                                    },
                                                    {
                                                    "fieldData": {
                                                        "Description": "",
                                                        "Completion date": "",
                                                        "Status": "Completed",
                                                        "Priority": "",
                                                        "Category": "",
                                                        "Deadline": "",
                                                        "Task": "Test"
                                                    },
                                                    "portalData": {
                                                        "Attachment": [],
                                                        "Contact Portal": []
                                                    },
                                                    "recordId": "37",
                                                    "modId": "1",
                                                    "portalDataInfo": [
                                                        {
                                                        "database": "Sample",
                                                        "table": "Attachment",
                                                        "foundCount": 0,
                                                        "returnedCount": 0
                                                        },
                                                        {
                                                        "portalObjectName": "Person in charge portal",
                                                        "database": "Sample",
                                                        "table": "assignment",
                                                        "foundCount": 0,
                                                        "returnedCount": 0
                                                        }
                                                    ]
                                                    }
                                                ]
                                            },
                                            "messages": [
                                                {
                                                "code": "0",
                                                "message": "OK"
                                                }
                                            ]
                                        }, null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="createrecord">
                2.&nbsp;<span className="material-symbols-outlined">format_list_bulleted_add</span>&nbsp;{translate('createrecord')}
            </Typography>
            <p><strong>{translate('createrecord')}</strong> là một hành động để tạo một bản ghi mới.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là nơi lưu trữ đầu ra của hành động này.</td>
                                <td>$newRecord_1</td>
                            </tr>
                            <tr>
                                <td>{translate('providerid')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là <strong>ID nhà cung cấp</strong> của kết nối Filemaker (xem <Box component={Link} to="/control-center/documentation/connections/filemaker">tại đây</Box> để tạo kết nối).</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('layout')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là tên layout.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('fielddata')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="object" />
                                </td>
                                <td>Là tên trường và giá trị để thiết lập.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="object" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$newRecord_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('providerid')}</span>
                            <div>filemaker-1a2b3c4d5e6g7h</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('layout')}</span>
                            <div>Task Details</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('fielddata')}</span>
                            <div>{`{"task": "test", "status": "unprocessed"}`}</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                        {
                                            "response": {
                                                "recordId": "36",
                                                "modId": "0"
                                            },
                                            "messages": [
                                                {
                                                "code": "0",
                                                "message": "OK"
                                                }
                                            ]
                                        }
                                        , null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="getsinglerecordbyid">
                3.&nbsp;<span className="material-symbols-outlined">feed</span>&nbsp;{translate('getsinglerecordbyid')}
            </Typography>
            <p><strong>{translate('getsinglerecordbyid')}</strong> là một hành động truy xuất một bản ghi theo ID.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là nơi lưu trữ đầu ra của hành động này.</td>
                                <td>$singleRecord_1</td>
                            </tr>
                            <tr>
                                <td>{translate('providerid')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là <strong>ID nhà cung cấp</strong> của kết nối Filemaker (xem <Box component={Link} to="/control-center/documentation/connections/filemaker">tại đây</Box> để tạo kết nối).</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('layout')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là tên layout.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('recordid')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="number" />
                                </td>
                                <td>Là ID của bản ghi.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="object" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$singleRecord_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('providerid')}</span>
                            <div>filemaker-1a2b3c4d5e6g7h</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('layout')}</span>
                            <div>Task Details</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('recordid')}</span>
                            <div>36</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                        {
                                            "response": {
                                                "dataInfo": {
                                                    "database": "Sample",
                                                    "layout": "Task Details",
                                                    "table": "task",
                                                    "totalRecordCount": 3,
                                                    "foundCount": 1,
                                                    "returnedCount": 1
                                                },
                                                "data": [
                                                    {
                                                    "fieldData": {
                                                        "description": "",
                                                        "completion date": "",
                                                        "status": "completion",
                                                        "priority": "",
                                                        "category": " ",
                                                        " Deadline ": " ",
                                                        " Task ": " Test "
                                                    },
                                                    " portalData ": {
                                                        " Attachment ": [],
                                                        " Contact Portal ": []
                                                    },
                                                    " recordId ": " 36 ",
                                                    " modId ": " 1 ",
                                                    " portalDataInfo ": [
                                                        {
                                                        "database ": " Sample ",
                                                        " table ": " Attachments ",
                                                        " foundCount ": 0,
                                                        " returnedCount ": 0
                                                        },
                                                        {
                                                        "portalObjectName ": " Person Portal ",
                                                        " database ": " Sample ",
                                                        " table ": " Assignment ",
                                                        " foundCount ": 0,
                                                        " returnedCountedCount ": 0
                                                        }
                                                    ]
                                                    }
                                                ]
                                            },
                                            "messages": [
                                                {
                                                "code": "0",
                                                "message": "OK"
                                                }
                                            ]
                                        }, null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="editrecord">
                4.&nbsp;<span className="material-symbols-outlined">edit_square</span>&nbsp;{translate('editrecord')}
            </Typography>
            <p><strong>{translate('editrecord')}</strong> là một hành động để chỉnh sửa một bản ghi hiện có.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là nơi lưu trữ đầu ra của hành động này.</td>
                                <td>$editRecord_1</td>
                            </tr>
                            <tr>
                                <td>{translate('providerid')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là <strong>ID nhà cung cấp</strong> của kết nối Filemaker (xem <Box component={Link} to="/control-center/documentation/connections/filemaker">tại đây</Box> để tạo kết nối).</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('layout')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là tên layout.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('recordid')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="number" />
                                </td>
                                <td>Là ID của bản ghi.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('fielddata')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="object" />
                                </td>
                                <td>Là tên trường và giá trị để thiết lập.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="object" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$editRecord_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('providerid')}</span>
                            <div>filemaker-1a2b3c4d5e6g7h</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('layout')}</span>
                            <div>Task Details</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('recordid')}</span>
                            <div>36</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('fielddata')}</span>
                            <div>{`{"task": "test", "status": "completed"}`}</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                        {
                                            "response": {
                                                "modId": "1"
                                            },
                                            "messages": [
                                                {
                                                "code": "0",
                                                "message": "OK"
                                                }
                                            ]
                                        }, null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="deleterecord">
                5.&nbsp;<span className="material-symbols-outlined">delete</span>&nbsp;{translate('deleterecord')}
            </Typography>
            <p><strong>{translate('deleterecord')}</strong> là một hành động để xóa một bản ghi hiện có.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là nơi lưu trữ đầu ra của hành động này.</td>
                                <td>$deleteRecord_1</td>
                            </tr>
                            <tr>
                                <td>{translate('providerid')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là <strong>ID nhà cung cấp</strong> của kết nối Filemaker (xem <Box component={Link} to="/control-center/documentation/connections/filemaker">tại đây</Box> để tạo kết nối).</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('layout')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là tên layout.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('recordid')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="number" />
                                </td>
                                <td>Là ID của bản ghi.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="object" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$deleteRecord_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('providerid')}</span>
                            <div>filemaker-1a2b3c4d5e6g7h</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('layout')}</span>
                            <div>Task Details</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('recordid')}</span>
                            <div>36</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                        {
                                            "response": {},
                                            "messages": [
                                                {
                                                "code": "0",
                                                "message": "OK"
                                                }
                                            ]
                                        }, null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="duplicaterecord">
                6.&nbsp;<span className="material-symbols-outlined">content_copy</span>&nbsp;{translate('duplicaterecord')}
            </Typography>
            <p><strong>{translate('duplicaterecord')}</strong> là một hành động để sao chép một bản ghi hiện có.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là nơi lưu trữ đầu ra của hành động này.</td>
                                <td>$deleteRecord_1</td>
                            </tr>
                            <tr>
                                <td>{translate('providerid')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là <strong>ID nhà cung cấp</strong> của kết nối Filemaker (xem <Box component={Link} to="/control-center/documentation/connections/filemaker">tại đây</Box> để tạo kết nối).</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('layout')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là tên layout.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('recordid')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="number" />
                                </td>
                                <td>Là ID của bản ghi.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="object" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$deleteRecord_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('providerid')}</span>
                            <div>filemaker-1a2b3c4d5e6g7h</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('layout')}</span>
                            <div>Task Details</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('recordid')}</span>
                            <div>36</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                        {
                                            "response": {},
                                            "messages": [
                                                {
                                                "code": "0",
                                                "message": "OK"
                                                }
                                            ]
                                        }, null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="findrecords">
                7.&nbsp;<span className="material-symbols-outlined">search</span>&nbsp;{translate('findrecords')}
            </Typography>
            <p><strong>{translate('findrecords')}</strong> là một hành động để tìm kiếm các bản ghi.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là nơi lưu trữ đầu ra của hành động này.</td>
                                <td>$findRecords_1</td>
                            </tr>
                            <tr>
                                <td>{translate('providerid')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là <strong>ID nhà cung cấp</strong> của kết nối Filemaker (xem <Box component={Link} to="/control-center/documentation/connections/filemaker">tại đây</Box> để tạo kết nối).</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('layout')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là tên layout.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('query')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="array" />
                                </td>
                                <td>Là một tham số truy vấn.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="object" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$findRecords_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('providerid')}</span>
                            <div>filemaker-1a2b3c4d5e6g7h</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('layout')}</span>
                            <div>Task Details</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('query')}</span>
                            <div>{`[{"task": "test", "omit": "true"}]`}</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                        {
                                            "response": {
                                                "dataInfo": {
                                                    "database": "Sample",
                                                    "layout": "task details",
                                                    "table": "task",
                                                    "totalRecordCount": 3,
                                                    "foundCount": 1,
                                                    "returnedCount": 1
                                                },
                                                "data": [
                                                    {
                                                    "fieldData": {
                                                        "description": "",
                                                        "completion date": "",
                                                        "status": "",
                                                        "priority": "",
                                                        "category": "",
                                                        "Deadline": "",
                                                        "Task": ""
                                                    },
                                                    "portalData": {
                                                        "Attachment": [],
                                                        "Contact Portal": []
                                                    },
                                                    "recordId": "34",
                                                    "modId": "0",
                                                    "portalDataInfo": [
                                                        {
                                                        "database": "Sample",
                                                        "table": "Attachment",
                                                        "foundCount": 0,
                                                        "returnedCount": 0
                                                        },
                                                        {
                                                        "portalObjectName": "Contact Portal ",
                                                        " database ": " Sample ",
                                                        " table ": " Assignment ",
                                                        " foundCount ": 0,
                                                        " returnedCountedCount ": 0
                                                        }
                                                    ]
                                                    }
                                                ]
                                            },
                                            "messages": [
                                                {
                                                "code": "0",
                                                "message": "OK"
                                                }
                                            ]
                                        }, null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="executescript">
                8.&nbsp;<span className="material-symbols-outlined">play_circle</span>&nbsp;{translate('executescript')}
            </Typography>
            <p><strong>{translate('executescript')}</strong> là một hành động để thực thi tập lệnh.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là nơi lưu trữ đầu ra của hành động này.</td>
                                <td>$executeScript_1</td>
                            </tr>
                            <tr>
                                <td>{translate('providerid')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là <strong>ID nhà cung cấp</strong> của kết nối Filemaker (xem <Box component={Link} to="/control-center/documentation/connections/filemaker">tại đây</Box> để tạo kết nối).</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('layout')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là tên layout.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('scriptname')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là tên tập lệnh đích để thực thi.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('params')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="any" />
                                </td>
                                <td>Là một tham số truyền vào.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="object" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$executeScript_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('providerid')}</span>
                            <div>filemaker-1a2b3c4d5e6g7h</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('layout')}</span>
                            <div>Task Details</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('scriptname')}</span>
                            <div>Add new record</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('params')}</span>
                            <div>{`{"task": "test", "status": "unprocessed"}`}</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                        {
                                            "response": {},
                                            "messages": [
                                                {
                                                "code": "0",
                                                "message": "OK"
                                                }
                                            ]
                                        }, null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="uploadtocontainerfield">
                9.&nbsp;<span className="material-symbols-outlined">cloud_upload</span>&nbsp;{translate('uploadtocontainerfield')}
            </Typography>
            <p><strong>{translate('uploadtocontainerfield')}</strong> là một hành động để tải tệp lên trường container.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là nơi lưu trữ đầu ra của hành động này.</td>
                                <td>$uploadToContainerField_1</td>
                            </tr>
                            <tr>
                                <td>{translate('providerid')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là <strong>ID nhà cung cấp</strong> của kết nối Filemaker (xem <Box component={Link} to="/control-center/documentation/connections/filemaker">tại đây</Box> để tạo kết nối).</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('layout')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là tên layout.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('recordid')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="number" />
                                </td>
                                <td>Là ID của bản ghi.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('containerfieldname')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là tên trường container.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('filepath')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là đường dẫn của tệp bạn muốn tải lên.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="object" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$uploadToContainerField_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('providerid')}</span>
                            <div>filemaker-1a2b3c4d5e6g7h</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('layout')}</span>
                            <div>Task Details</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('recordid')}</span>
                            <div>36</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('containerfieldname')}</span>
                            <div>attachment</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('filepath')}</span>
                            <div>/tmp/downloads/sktwi174l9kzzqc2/20221025-003483/combine.pdf</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                        {
                                            "response": {},
                                            "messages": [
                                                {
                                                "code": "0",
                                                "message": "OK"
                                                }
                                            ]
                                        }, null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="setglobalfields">
                10.&nbsp;<span className="material-symbols-outlined">public</span>&nbsp;{translate('setglobalfields')}
            </Typography>
            <p><strong>{translate('setglobalfields')}</strong> là một hành động ghi dữ liệu vào trường global.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là nơi lưu trữ đầu ra của hành động này.</td>
                                <td>$setGlobalFields_1</td>
                            </tr>
                            <tr>
                                <td>{translate('providerid')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là <strong>ID nhà cung cấp</strong> của kết nối Filemaker (xem <Box component={Link} to="/control-center/documentation/connections/filemaker">tại đây</Box> để tạo kết nối).</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('globalfields')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="object" />
                                </td>
                                <td>Là tên của trường global và giá trị muốn ghi vào.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="object" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$setGlobalFields_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('providerid')}</span>
                            <div>filemaker-1a2b3c4d5e6g7h</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('globalfields')}</span>
                            <div>{`{"Task Details::search": "test"}`}</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                        {
                                            "response": {},
                                            "messages": [
                                                {
                                                "code": "0",
                                                "message": "OK"
                                                }
                                            ]
                                        }, null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </Box>
    );
}
export default withTranslate(Vi);